import React from 'react';
import { call, takeEvery } from 'redux-saga/effects';
import showToast from '@/utils/toasts';
import actions, { configurationCodes } from '../constants';
import AutoApprovalToast from '../components/AutoApprovalToast';
import DefaultRoleToast from '../components/DefaultRoleToast';

export function* configurationUpdateToast({ result, code }) {
  if (code === configurationCodes.DEFAULT_APPROVAL) {
    yield call(showToast, <AutoApprovalToast on={result.value.value} />);
  } else if (code === configurationCodes.DEFAULT_ROLE) {
    yield call(showToast, <DefaultRoleToast name={result.name} />);
  }
}

export default function* configurationsToasts() {
  yield takeEvery(actions.UPDATE_CONFIGURATION_SUCCESS, configurationUpdateToast);
}
